// Shared DOMPurify config for rich HTML email signatures.
// Signatures are almost always table-based (logo + photo + social icons laid
// out in <table> cells with explicit width/height attributes). The default
// slim allowlist strips those, collapsing the layout — so this config widens
// to an email-safe set while retaining DOMPurify's default XSS guarantees
// (no <script>, no event handlers, no javascript:/data: URIs on href/src).
export const SIGNATURE_SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    "a", "b", "i", "u", "strong", "em", "br", "hr",
    "p", "div", "span", "small", "sub", "sup", "font", "pre", "code", "blockquote",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "img",
    "table", "thead", "tbody", "tfoot", "tr", "td", "th", "colgroup", "col", "caption",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "title",
    "src", "alt", "srcset", "loading",
    "style", "class", "id",
    "width", "height",
    "align", "valign", "bgcolor", "color", "size", "face",
    "cellpadding", "cellspacing", "border",
    "colspan", "rowspan",
  ],
  ALLOW_DATA_ATTR: false,
};
